import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BheFilter } from "src/app/models/BoletaHonorarios/BheFilter";
import { DatosEmisorBhe } from "src/app/models/BoletaHonorarios/DatosEmisorBhe";
import { EmisorDireccionBH } from "src/app/models/BoletaHonorarios/EmisorDireccionBH";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { PersonaAutorizada } from "src/app/models/PersonaAutorizada";
import { Comuna } from "src/app/models/Region/Comuna";
import { Region } from "src/app/models/Region/Region";
import { BheService } from "src/app/services/bhe.service";
import { EmisionBheService } from "src/app/services/emision-bhe.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import Swal from "sweetalert2";
import { filter } from "rxjs/operators";
import { PersonasAutorizadasService } from "../../../../services/paseronas-autorizadas.service";
import { Observable } from "rxjs/internal/Observable";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-emisor-bhe",
	templateUrl: "./emisor-bhe.component.html",
	styleUrls: ["./emisor-bhe.component.scss"],
})
export class EmisorBheComponent implements OnInit {
	private receptorRetencion$: Observable<boolean>;
	loadingPersonas: boolean = false;
	loadingDirecciones: boolean = false;
	emisorAsociadoFormGroup: FormGroup;
	datosEmisorBhe: DatosEmisorBhe = new DatosEmisorBhe();
	personasAutorizadas: PersonaAutorizada[] = [];
	personaSeleccionada: PersonaAutorizada;
	currentEmisorId: string = this.tokenService.getCompany();
	currentEmisor: Emisor = (JSON.parse(this.localStorage.getEmisores()) as Emisor[]).find((em) => em.emisorId == this.currentEmisorId);
	direccionesSource: any[] = [];
	public mostrarRutEmisor: boolean = false;
	public showDireccionInputs: boolean = true;
	constructor(private tokenService: TokenStorageService, private personaAutorizadaService: PersonasAutorizadasService, private ref: ChangeDetectorRef, private localStorage: LocalStorageService, private formBuilder: FormBuilder, private emisionBheService: EmisionBheService, private bheService: BheService, private utilities: UtilitiesService, private sessionUserService: SessionUserService) {
		this.createForm();
		this.f().mostrarDescripcion.setValue("true");
		this.consultarDireccionesEmisor(this.currentEmisorId);
	}

	ngOnInit(): void {
		// const subscriptionDatosCreacion = this.receptorRetencion$.subscribe((datos) => {
		// 	this.datosCreacionToRequest(datos);
		// });
		this.sessionUserService.verificarSesionUsuario();
		this.getAuthorizedPersons();
		this.onSubmit();
	}

	getRutOperando(): string {
		if (!this.currentEmisor) {
			return '';
		}
		
		if (this.currentEmisor.bheEmpresa) {
			return this.currentEmisor.rutString || '';
		}
		
		return this.tokenService.getCertificadoRut() || '';
	}

	getNombreOperando(): string {
		if (!this.currentEmisor) {
			return '';
		}

		if (this.currentEmisor.bheEmpresa) {
			return this.currentEmisor.razonSocial || '';
		}

		return this.tokenService.getCertificadoNombre() || '';
	}

	public seleccionarPersona(persona: any): void {
		this.personaSeleccionada = persona;
		this.onSubmit();
	}

	getAuthorizedPersons() {
		this.loadingPersonas = true;
		this.personaAutorizadaService.getAuthorizedPersonsByEmisor(this.currentEmisorId).subscribe(
			(result) => {
				this.loadingPersonas = false;
				this.personasAutorizadas = result.data.filter((x) => x.tipoPersona == 2);
				this.personaSeleccionada = this.personasAutorizadas[0];
				this.f().personaAutorizada.patchValue(this.personasAutorizadas[0]);
				this.ref.detectChanges();
			},
			(error) => {
				this.loadingPersonas = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Personas Autorizadas para Cesion No Encontradas",
					text: "Error al buscar personas autorizadas para cesion del emisor" + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	createForm() {
		this.emisorAsociadoFormGroup = this.formBuilder.group({
			direccion: [],
			personaAutorizada: [],
			comuna: [],
			fono: [],
			fax: [],
			mostrarDescripcion: [],
			deTerceros: [false],
		});
	}
	changeMuestraDescripcion(event) {
		this.onSubmit();
	}

	onSubmit() {
		if (this.emisorAsociadoFormGroup.valid) {
			this.formDataToRequest();
			this.emisionBheService.setEmisorData(this.datosEmisorBhe);
		}
	}

	f() {
		return this.emisorAsociadoFormGroup.controls;
	}

	formDataToRequest() {
		this.datosEmisorBhe.emisorId = this.currentEmisor.emisorId;
		let direccion: EmisorDireccionBH = this.f().direccion.value;
		this.datosEmisorBhe.direccionEmisor = direccion ? direccion.direccion : "Direccion Genérica";
		this.datosEmisorBhe.codigoDireccionEmisor = direccion ? direccion.posicionSii : 1;
		let muestraDescripcion = this.f().mostrarDescripcion.value;
		let fono = this.f().fono.value;
		let fax = this.f().fax.value;
		this.datosEmisorBhe.comunaEmisor = this.f().comuna.value;
		this.datosEmisorBhe.terceros = this.f().deTerceros.value;
		this.datosEmisorBhe.personaAutorizada = this.personaSeleccionada;
	}
	changeTipoBhe(event) {
		this.f().deTerceros.patchValue(event.target.checked);
		this.showDireccionInputs = !event.target.checked;
		this.onSubmit();
	}

	consultarDireccionesEmisor(emisorId) {
		this.loadingDirecciones = true;
		this.bheService.directionsForBhe(emisorId).subscribe(
			(result) => {
				this.direccionesSource = result.data as EmisorDireccionBH[];
				this.loadingDirecciones = false;
				if (this.direccionesSource.length > 0) {
					this.f().direccion.patchValue(this.direccionesSource[0]);
					//SE REENVIA DATOS DE FORMULARIO A SERVICIO Y COMPONENTE PADRE XQ PUEDE QUE NO HAYA MAS INTERACCION CON EL FORMULARIO TRAS ACTUALIZARSE
					this.onSubmit();
				}
				this.ref.detectChanges();
			},
			(error) => {
				this.loadingDirecciones = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en direcciones",
					text: "No fue posible obtener la lista de direcciones de SII del emisor actual. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
}
